module.exports = __webpack_public_path__ + "img/logo-06-red.33462065.png";